import React from 'react';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { partial } from 'lodash';
import DragCanvas, { DragCanvasImage } from '@dyl/components/DragCanvas';
import ImagePicker from '@dyl/components/ImagePicker';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { useImage } from '@dyl/systems/ImagesManager';
import PreviousImages from './utils/PreviousImages';

const useStyles = makeStyles(theme => ({
    pickersContainer: {
        marginBottom: '8px',
        maxWidth: theme.breakpoints.values.md,
    },
}))

export default function MessageEditor(
    {
        index,
        draggable = true,
        backgroundImagePath = 'background_image',
    }) {
    const classes = useStyles();

    const [backgroundImageId] = useTaskField(backgroundImagePath);
    const { src: backgroundImageSrc } = useImage(backgroundImageId);

    return (
        <>
            <Grid container className={classes.pickersContainer}>
                <ImagePickerContainer item itemIndex={index}/>
            </Grid>

            <DragCanvas backgroundSrc={backgroundImageSrc}>
                <PreviousImages index={index} />
                <Draggable
                    itemIndex={index}
                    disabled={!draggable}
                />
            </DragCanvas>
        </>
    );
}

function ImagePickerContainer({ itemIndex }) {
    const useField = partial(useTaskField, 'items', itemIndex, 'answers', 0);
    const [imageId, setImageId, imageError] = useField('image_id');

    return (
        <>
            <ImagePicker
                label={`Prompt Image`}
                value={imageId}
                onChange={setImageId}
                fullWidth
                error={!!imageError}
                helperText={imageError}
                allowEmpty
            />
        </>
    );
}

export function Draggable({ itemIndex, disabled = false, imageFieldName = 'image_id' }) {
    const useField = partial(useTaskField, 'items', itemIndex, 'answers', 0);
    const [imageId] = useField(imageFieldName);
    const { src } = useImage(imageId);
    const [coordinates, setCoordinates] = useField('coordinates');

    return (
        <DragCanvasImage
            disabled={disabled}
            src={src}
            alt={imageId}
            coordinates={coordinates}
            onCoordinatesChange={setCoordinates}
        />
    );
}